import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Main from "./code/Main";



ReactDOM.render(
  <Main/>,
 document.getElementById('root')
);

